module.exports = __webpack_public_path__ + "static/media/home-hero-image.faf3378c.png";